import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import casePeerLogoSm from '../../../../assets/logo_8am_sm.svg';
import { white } from '../../../../styles/colors';
import { baseStyleSheet } from '../../../../styles/styles';
import { EightAmIntegrationGraphic } from '../../../svgs/graphics/EightAmIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { styleSheet } from './styles';

export const DashboardCasePeerIntegrationCard = () => {
	const { getLogoImgProps, getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } =
		useIntegrationCard({
			closeIntegrationEventName: 'CasePeerIntegrationClosed',
			enableUrlPath: '/integrations/CasePeer',
			integrationEnableEventName: 'CasePeerIntegrationEnableClick',
			pendingAction: Api.PendingActions.ConnectCasePeer,
			checkApiPendingAction: true,
		});

	if (!showCard) {
		return null;
	}

	return (
		<IntegrationCard
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={EightAmIntegrationGraphic}
			headerLabel='CasePeer Integration'
			logoBgColor={white}
			logoImgProps={getLogoImgProps({
				alt: 'CasePeer Logo',
				className: css(styleSheet.logo),
				src: casePeerLogoSm,
			})}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect with CasePeer',
				styleDeclaration: [baseStyleSheet.ctaButtonReverse, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>
				We are excited to announce that you can integrate your CasePeer account with Levitate. With this integration, we
				will have the ability to pull client information, including names, email, phone number, birthdays, and more
				&mdash; making staying in touch even easier.
			</p>
		</IntegrationCard>
	);
};
